<template>
  <div
    class="full-width-banner"
    :class="`full-width-banner_${theme || 'green'}`">
    <div class="container full-width-banner__inner">
      <div class="full-width-banner__text">
        <default-title
          v-if="title"
          class="full-width-banner__title"
          pre_wrap
          :white="theme !== 'light'"
          :title="title"
          :title_tag="title_tag"/>
        <html-block
          v-if="content"
          class="full-width-banner__content"
          :content="content"/>
      </div>
      <default-button
        v-if="button_text"
        class="full-width-banner__button"
        :href="button_link">
        {{ button_text }}
      </default-button>
    </div>
  </div>
</template>

<script>
import HtmlBlock from "../small_parts/HtmlBlock";
import DefaultTitle from "../small_parts/DefaultTitle.vue";
import DefaultButton from "../slots/DefaultButton.vue";

export default {
  name: "FullWidthBanner",
  components: {
    DefaultButton,
    DefaultTitle,
    HtmlBlock
  },
  // `button_text` / `button_link` — butonul din dreapta sectiunii, cerut la recenzie.
  // Nu e in macheta: acolo banda verde are doar titlu si un rand de text.
  // Gol inseamna fara buton, deci un banner fara ele randeaza exact ca inainte.
  props: {
    /**props**/
    title: {
      type: String,
      default: '',
      admin_type: 'textarea',
    },
    title_tag: {
      type: String,
      default: 'h2',
      admin_type: 'select',
      admin_data_values: [
        'h1', 'h2', 'h3', 'h4', 'h5', 'h6'
      ],
    },
    content: {
      type: String,
      default: '',
      admin_type: 'editor',
    },
    button_text: {
      type: String,
      default: '',
      admin_type: 'input',
    },
    button_link: {
      type: String,
      default: '',
      admin_type: 'input',
    },
    theme: {
      type: String,
      default: 'green',
      admin_type: 'select',
      admin_data_values: [
        'green',
        'black',
        'light'
      ],
    },
    /**props**/
  }
}
</script>
